import { IListaStatusEtapa } from "../../../Interfaces/Repasse/StatusEtapa/StatusEtapaInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarStatusPorTipoCasoService(idTipoCaso: number) {
    return Service(
        Axios.get<Array<IListaStatusEtapa>>(
            `/home/statusetapa/listarstatusportipocaso?idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function EditarStatusEtapaService(requestBody: IListaStatusEtapa) {
    return Service(
        Axios.put(`/home/statusetapa/atualizastatusetapa`, requestBody)
    );
}

export async function DeletarStatusPorTipoCasoService(idStatusEtapa: number) {
    return Service(
        Axios.delete(
            `/home/statusetapa/deletastatusetapa?idStatusEtapa=${idStatusEtapa}`
        )
    );
}

export async function CriarStatusPorTipoCasoService(
    requestBody: IListaStatusEtapa
) {
    return Service(
        Axios.post(`/home/statusetapa/inserestatusetapa`, requestBody)
    );
}
